import type { FC } from 'react';
import { lazy } from 'react';
import { useParams } from 'react-router';
import type { CapacityManagementRootRequest } from 'src/apis/capacity-management/use-capacity-management-root';
import { useCmNetworkPoint } from 'src/apis/capacity-management/use-cm-network-point';
import { useInternalBooking } from 'src/apis/capacity-management/use-internal-booking';
import { useInternalBookings } from 'src/apis/capacity-management/use-internal-bookings';
import type { NetworkPointRequest } from 'src/apis/monolith/use-network-point';
import type { Successful } from 'src/hooks/use-axios';
import { useTitle } from 'src/hooks/use-title';

const Page = lazy(() => import('./page'));

type Props = {
  networkPoint: Successful<NetworkPointRequest>;
  capacityManagementRoot: Successful<CapacityManagementRootRequest>;
};

export const EditInternalBooking: FC<Props> = ({
  capacityManagementRoot,
  networkPoint,
}) => {
  const { oldNetworkPointId, bookingId } = useParams<{
    oldNetworkPointId: string;
    bookingId: string;
  }>();

  const cmNetworkPoint = useCmNetworkPoint({
    capacityManagementRoot,
    networkPoint,
  });

  const internalBookings = useInternalBookings({ cmNetworkPoint });

  const internalBooking = useInternalBooking({
    internalBookings,
    oldNetworkPointId,
    bookingId,
  });

  useTitle('Edit Internal Booking');

  return (
    <Page cmNetworkPoint={cmNetworkPoint} internalBooking={internalBooking} />
  );
};
